<template>
    <v-row>
        <v-dialog v-model="showDialog" persistent max-width="350px">
            <v-form ref="form">
                <v-card>
                    <v-card-title style="padding: 10px 0 0 10px; height: 30px;">
                        <v-col cols="12">
                            <span style="position: relative; top: -15px;">{{ $t('send-email.title') }}</span>
                            <v-btn icon style="top: -20px; left: 10px; float: right;">
                                <v-icon @click="showDialog=false">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-card-title>
                    <v-card-subtitle style="padding: 0 22px 20px 22px;">
                        <span style="position: relative; top: 25px;">{{ $t('send-email.subtitle') }}</span>
                    </v-card-subtitle>
                    <v-card-text style="padding: 5px;">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="email"
                                        autocomplete="none"
                                        :rules="[validationRules.required, validationRules.email]"
                                        :label="$t('send-email.email')"
                                        type="email"/>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#c01033" text class="btn-link"  style="width: 100px;" @click="showDialog=false">{{ $t('dialog.cancel') }}</v-btn>
                        <v-btn class="wemob-btn primary" style="width: 100px;" @click="doOk()">{{ $t('dialog.ok') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
    name: 'SendEmailDialog',
    mixins: [ BaseModule ],
    data() {
        return {
            email: null,
            showDialog: false,
            msgCb: null,
        }
    },
    methods: {
        isVisible: function() {
            return this.showDialog;
        },
        close: function() {
            this.showDialog = false; 
        },
        open: function(msgCb) {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            this.email = null;

            this.showDialog = true;            
            this.msgCb = msgCb;
        },
        doOk: function() {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.showDialog = false;

            if (this.msgCb) {
                this.msgCb(this.email);
            }
        }
    },
  }
</script>